<template>
  <div class="collapse" :class="{hide:isShow}">
    <div class="left">
      <slot></slot>
    </div>
    <div class="right">
      <el-button icon="el-icon-search" @click="getDataList">{{buttonText}}</el-button>
      <div @click="clickToShow">
        <i v-if="!isShow" class="el-icon-caret-bottom"></i>
        <i v-else class="el-icon-caret-top"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    buttonText: {
      type: String,
      default: 'Search',
    },
  },
  data() {
    return {
      isShow: true,
    }
  },
  methods: {
    clickToShow() {
      this.isShow = !this.isShow
    },
    getDataList() {
      this.$emit('getDataList', this.queryInfoparams)
    },
  },
}
</script>

<style lang="less" scoped>
.collapse {
  display: flex;

  .left {
    display: flex;
    // width: 80%;
    flex: 1;
    flex-wrap: wrap;

    .collapse-item {
      display: flex;
      align-items: center;
      width: 30%;
      margin-right: 40px;
      margin-bottom: 10px;
      /deep/span {
        // color: #ccc;
        color: #6a6767;

        text-align: center;
        padding-right: 10px;
        white-space: nowrap;
      }
      /deep/div {
        width: 100%;
      }
    }
  }
  .right {
    width: 10%;
    height: 40px;
    display: flex;
    align-content: center;
    justify-content: space-around;
    .el-button {
      height: 40px;
    }
    div {
      display: flex;
      align-items: center;
    }
  }
}

.hide {
  height: 50px;
  overflow: hidden;
}
</style>